/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import color from '../_style/color';

const Container = styled.div
  .withConfig({ shouldForwardProp: (props) => !['vertical'].includes(props) })
  .attrs((props) => ({
    vertical: props.vertical,
    filled: props.filled,
    size: props.size,
  }))`
  cursor: pointer;
  & > div {
    display: ${({ vertical }) => (vertical ? 'block' : 'inline-block')};
    width: ${({ size }) => (size === 'small' ? '3px' : `5px`)};
    height: ${({ size }) => (size === 'small' ? '3px' : `5px`)};
    margin: 2px;
    border-radius: 50%;
    border: ${({ filled }) =>
      filled ? 'none' : `1px solid ${color.highgray}`};
    background-color: ${({ filled }) =>
      filled ? color.highgray : 'transparent'};
  }
`;
const IconMoreOptions = (props) => {
  return (
    <Container {...props}>
      <div />
      <div />
      <div />
    </Container>
  );
};

export default IconMoreOptions;
